import React from "react";
import { ShieldCheck, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourFirstStepTowardChange() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="6587" id="start-your-remodel" className="dark bg-primary text-primary-foreground relative overflow-hidden py-24 sm:py-32">
      {}
      <div className="absolute inset-0 bg-primary z-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--color-accent)_0%,_transparent_70%)] opacity-5 mix-blend-overlay" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--color-secondary)_0%,_transparent_50%)] opacity-10 mix-blend-soft-light" />
      </div>

      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="mx-auto max-w-3xl space-y-8">
          <h2 className="text-4xl font-serif font-medium tracking-tight text-white sm:text-5xl md:text-6xl drop-shadow-sm">
            Start Your Masterpiece Remodel
          </h2>
          
          <p className="text-lg text-primary-foreground/90 sm:text-xl leading-relaxed max-w-2xl mx-auto">
            Transform your home with 20+ years of expert craftsmanship. From luxury bathrooms to custom kitchens, we bring your vision to life with integrity and precision.
          </p>

          <div className="flex flex-col items-center gap-6 pt-4">
            <Button asChild size="lg" className="h-14 px-8 text-lg rounded-sm bg-accent text-accent-foreground hover:bg-accent/90 shadow-lg hover:shadow-xl transition-all duration-300 border-none">
              <Link to="/ContactPage">
                Schedule Your Free Consultation
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>

            <Badge variant="outline" className="border-primary-foreground/20 bg-primary-foreground/10 text-primary-foreground backdrop-blur-sm px-4 py-1.5 text-sm font-medium tracking-wide">
              <ShieldCheck className="mr-1.5 h-4 w-4" />
              Licensed & Insured | 20+ Years Experience
            </Badge>
          </div>
        </div>
      </div>
    </section>;
}